<div class="reports-page">
  @if(movementsBlocked) {
  <div class="reports-alert reports-alert--error">
    <p-message severity="error" icon="pi pi-ban"
      [text]="'REPORTS.BANNER_MOVEMENTS_BLOCKED' | translate:{ periods: openPeriodsDisplay }" />
  </div>
  }
  @if(showBanner) {
  <div class="reports-alert reports-alert--warn">
    <p-message severity="warn" icon="pi pi-exclamation-triangle"
      [text]="'REPORTS.BANNER_UNCLOSED' | translate:{ month: previousMonthName }" />
  </div>
  }

  <header class="reports-hero">
    <div class="reports-hero__inner">
      <div class="reports-hero__brand">
        <button type="button" class="reports-hero__back" (click)="atras()" [attr.aria-label]="'REPORTS.BTN_BACK' | translate">
          <i class="pi pi-arrow-left" aria-hidden="true"></i>
        </button>
        <div class="reports-hero__text">
          <span class="reports-hero__eyebrow">{{ 'REPORTS.HERO_EYEBROW' | translate }}</span>
          <h1 class="reports-hero__title">{{ 'REPORTS.HEADER_SUBTITLE' | translate }}</h1>
        </div>
      </div>
      <div class="reports-hero__meta">
        @if (previousMonthName) {
        <span class="reports-hero__chip">
          <i class="pi pi-calendar" aria-hidden="true"></i>
          <span class="notranslate">{{ previousMonthName }}</span>
        </span>
        }
        <p-button data-tour="preview-close" type="button" icon="pi pi-lock" [loading]="loading"
          [label]="'REPORTS.BTN_CLOSE_REPORT' | translate" (click)="confirmarCerrarMovimiento()"
          styleClass="reports-hero__btn reports-hero__btn--cta" />
      </div>
    </div>
  </header>

  <article class="reports-document" id="reporteCard">
    <header class="reports-document__head">
      <div class="reports-document__logo">
        <img class="reports-document__logo-img" src="../../../assets/images/logo_mmm.png" alt="Logo MMM" />
      </div>
      <div class="reports-document__titles">
        <p class="reports-document__line">{{ 'REPORTS.HEADER_LINE_1' | translate }}</p>
        <p class="reports-document__line reports-document__line--bold">{{ 'REPORTS.HEADER_LINE_2' | translate }}</p>
        <p class="reports-document__subtitle">{{ 'REPORTS.HEADER_SUBTITLE' | translate }}</p>
      </div>
    </header>

    <div class="reports-document__meta" data-tour="preview-header">
      <div class="reports-document__field">
        <label class="reports-document__label">{{ 'REPORTS.FIELD_CHURCH' | translate }}</label>
        <input pInputText [(ngModel)]="iglesiaName" class="reports-document__input" readonly />
      </div>
      <div class="reports-document__field">
        <label class="reports-document__label">{{ 'REPORTS.FIELD_MONTH_YEAR' | translate }}</label>
        <input pInputText [(ngModel)]="previousMonthName" class="reports-document__input" readonly />
      </div>
    </div>

    <div class="reports-document__grid">
      <div class="reports-document__col">
        <section class="reports-section" data-tour="preview-spiritual">
          <h3 class="reports-section__title">{{ 'REPORTS.SECTION_SPIRITUAL' | translate }}</h3>
          <p-table [value]="informeEspiritualOptions" [paginator]="false" showGridlines
            styleClass="reports-table" [tableStyle]="{ 'min-width': '100%' }">
            <ng-template #header>
              <tr>
                <th class="text-center">#</th>
                <th>{{ 'REPORTS.COL_DESC' | translate }}</th>
                <th class="text-center">{{ 'REPORTS.COL_RESP' | translate }}</th>
              </tr>
            </ng-template>
            <ng-template #body let-product>
              <tr>
                <td class="text-center">{{ product.item }}</td>
                <td>{{ getInformeLabel(product.codigo, product.descripcion) }}</td>
                <td class="text-center">{{ product.valor }}</td>
              </tr>
            </ng-template>
          </p-table>
        </section>

        <section class="reports-section" data-tour="preview-financial">
          <h3 class="reports-section__title">{{ 'REPORTS.SECTION_FINANCIAL' | translate }}</h3>
          <p-table [value]="informeFinancieroIngresosOptions" [paginator]="false" showGridlines
            styleClass="reports-table" [tableStyle]="{ 'min-width': '100%' }">
            <ng-template pTemplate="header">
              <tr>
                <th class="text-center"></th>
                <th>{{ 'REPORTS.SUBSECTION_INCOME' | translate }}</th>
                <th class="text-center">{{ 'REPORTS.COL_AMOUNT' | translate }}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product>
              <tr [class.reports-table__row--total]="product.item === ''">
                @if(product.item === ''){
                <td class="text-center">{{ product.item }}</td>
                <td>{{ getInformeLabel(product.codigo, product.descripcion) }}</td>
                <td class="text-end">{{ product.valor | missionMoney }}</td>
                } @else {
                <td class="text-center">{{ product.item }}</td>
                <td>{{ getInformeLabel(product.codigo, product.descripcion) }}</td>
                <td class="text-end" [class.fw-bold]="(product?.valor || 0) > 0">{{ product.valor | missionMoney }}</td>
                }
              </tr>
            </ng-template>
          </p-table>

          <p-table [value]="informeFinancieroEgresosB1Options" [paginator]="false" showGridlines
            styleClass="reports-table reports-table--spaced" [tableStyle]="{ 'min-width': '100%' }">
            <ng-template #header>
              <tr>
                <th class="text-center"></th>
                <th>{{ 'REPORTS.SUBSECTION_EXPENSE_B1' | translate }}</th>
                <th class="text-center">{{ 'REPORTS.COL_AMOUNT' | translate }}</th>
              </tr>
            </ng-template>
            <ng-template #body let-product>
              <tr [class.reports-table__row--total]="product.item === ''">
                @if(product.item === ''){
                <td class="text-center">{{ product.item }}</td>
                <td>{{ getInformeLabel(product.codigo, product.descripcion) }}</td>
                <td class="text-end">{{ product.valor | missionMoney }}</td>
                } @else {
                <td class="text-center">{{ product.item }}</td>
                <td>{{ getInformeLabel(product.codigo, product.descripcion) }}</td>
                <td class="text-end" [class.fw-bold]="(product?.valor || 0) > 0">{{ product.valor | missionMoney }}</td>
                }
              </tr>
            </ng-template>
          </p-table>
        </section>
      </div>

      <div class="reports-document__col">
        <section class="reports-section" data-tour="preview-worker">
          <h3 class="reports-section__title">{{ 'REPORTS.SECTION_WORKER' | translate }}</h3>
          <p-table [value]="informeObreoOptions" [paginator]="false" showGridlines
            styleClass="reports-table" [tableStyle]="{ 'min-width': '100%' }">
            <ng-template #header>
              <tr>
                <th class="text-center">#</th>
                <th>{{ 'REPORTS.COL_DESC' | translate }}</th>
                <th class="text-center">{{ 'REPORTS.COL_RESP' | translate }}</th>
              </tr>
            </ng-template>
            <ng-template #body let-product>
              <tr>
                <td class="text-center vcenter">{{ product.item }}</td>
                <td>{{ getInformeLabel(product.codigo, product.descripcion) }}</td>
                <td class="text-center vcenter">
                  @if(!isExporting) {
                  <div class="cell">
                    <p-tag class="badge-export"
                      [severity]="isObreroAffirmative(product.valor) ? 'info' : 'secondary'">
                      {{ obreroTagLabel(isObreroAffirmative(product.valor)) }}
                    </p-tag>
                  </div>
                  } @else {
                  <span>{{ obreroTagLabel(isObreroAffirmative(product.valor)) }}</span>
                  }
                </td>
              </tr>
            </ng-template>
          </p-table>
        </section>

        <div data-tour="preview-b2">
        <p-table [value]="informeFinancieroEgresosB2Options" [paginator]="false" showGridlines
          styleClass="reports-table reports-table--spaced" [tableStyle]="{ 'min-width': '100%' }">
          <ng-template #header>
            <tr>
              <th class="text-center"></th>
              <th>{{ 'REPORTS.SUBSECTION_EXPENSE_B2' | translate }}</th>
              <th class="text-center">{{ 'REPORTS.COL_AMOUNT' | translate }}</th>
            </tr>
          </ng-template>
          <ng-template #body let-product>
            <tr [class.reports-table__row--total]="product.item === ''">
              @if(product.item === ''){
              <td class="text-center">{{ product.item }}</td>
              <td>{{ getInformeLabel(product.codigo, product.descripcion) }}</td>
              <td class="text-end">{{ product.valor | missionMoney }}</td>
              } @else {
              <td class="text-center">{{ product.item }}</td>
              <td>{{ getInformeLabel(product.codigo, product.descripcion) }}</td>
              <td class="text-end" [class.fw-bold]="(product?.valor || 0) > 0">{{ product.valor | missionMoney }}</td>
              }
            </tr>
          </ng-template>
        </p-table>
        </div>

        <div data-tour="preview-balance">
        <p-table [value]="informeFinancieroBalanceOptions" [paginator]="false" showGridlines
          styleClass="reports-table reports-table--spaced" [tableStyle]="{ 'min-width': '100%' }">
          <ng-template #header>
            <tr>
              <th>{{ 'REPORTS.SUBSECTION_BALANCE' | translate }}</th>
              <th class="text-center">{{ 'REPORTS.COL_AMOUNT' | translate }}</th>
            </tr>
          </ng-template>
          <ng-template #body let-product>
            <tr [class.reports-table__row--total]="product.codigo === 'BAL-FINAL'">
              @if(product.codigo === 'BAL-FINAL'){
              <td>{{ getInformeLabel(product.codigo, product.descripcion) }}</td>
              <td class="text-end">{{ product.valor | missionMoney }}</td>
              } @else {
              <td>{{ getInformeLabel(product.codigo, product.descripcion) }}</td>
              <td class="text-end" [class.fw-bold]="(product?.valor || 0) > 0">{{ product.valor | missionMoney }}</td>
              }
            </tr>
          </ng-template>
        </p-table>
        </div>

        <section class="reports-section reports-section--obs" data-tour="preview-observations">
          <h3 class="reports-section__title">{{ 'REPORTS.OBSERVATIONS' | translate }}</h3>
          @if(!isExporting) {
          <textarea rows="6" pTextarea [autoResize]="false" [(ngModel)]="observaciones"
            class="reports-document__textarea w-100" readonly></textarea>
          } @else {
          <div class="export-text-wrap" [innerText]="observaciones"></div>
          }
        </section>
      </div>
    </div>

    <footer class="reports-document__footer" data-tour="preview-signature">
      <div class="reports-document__field">
        <label class="reports-document__label">{{ 'REPORTS.FIELD_PASTOR' | translate }}</label>
        <input pInputText [(ngModel)]="pastorName" class="reports-document__input" readonly />
      </div>
      <div class="reports-document__signature">
        <label class="reports-document__label">{{ 'REPORTS.FIELD_SIGNATURE' | translate }}</label>
        <div class="reports-document__signature-box">
          @if (hasSignatureImage) {
          <img id="firmaImg" [src]="imageFirmaUrl!" [attr.alt]="('REPORTS.SIGNATURE_ALT' | translate)"
            (error)="handleSignatureImageError()" />
          } @else {
          <div class="reports-document__signature-empty">
            <i class="pi pi-pen-to-square" aria-hidden="true"></i>
            <span>{{ 'REPORTS.SIGNATURE_EMPTY' | translate }}</span>
          </div>
          }
        </div>
      </div>
    </footer>

    <p class="reports-document__quote">{{ 'REPORTS.FOOTER_QUOTE' | translate }}</p>
  </article>
</div>

<p-confirmdialog>
  <ng-template #message let-message>
    <div class="flex flex-col items-center w-full gap-4 border-b border-surface-200 dark:border-surface-700">
      <i [ngClass]="message.icon" class="!text-6xl text-primary-500"></i>
      <p>{{ message.message }}</p>
    </div>
  </ng-template>
</p-confirmdialog>

<p-dialog [(visible)]="showCierreDialog" [header]="'REPORTS.DIALOG_CLOSE_TITLE' | translate" [modal]="true"
  [closable]="true" styleClass="reports-dialog" [style]="{ width: 'min(420px, 92vw)' }">

  <div class="reports-dialog__body">
    <p class="reports-dialog__intro">
      {{ 'REPORTS.DIALOG_CLOSE_BODY_1' | translate }}
      <strong>{{ calcularTotalEgresosB2() | missionMoney }}</strong>{{ 'REPORTS.DIALOG_CLOSE_BODY_2' | translate }}
    </p>

    <div class="reports-dialog__field">
      <label class="reports-dialog__label">{{ 'REPORTS.DIALOG_FIELD_ACCOUNT' | translate }}</label>
      <p-select [(ngModel)]="cuentaOrigenCierre" [options]="cuentasActivasCierre" optionLabel="nombre"
        optionValue="id" [placeholder]="'REPORTS.DIALOG_PLACEHOLDER_ACCOUNT' | translate" [style]="{width:'100%'}"
        appendTo="body" />
    </div>

    <p class="reports-dialog__hint">
      {{ 'REPORTS.DIALOG_HINT' | translate }}
    </p>
  </div>

  <ng-template #footer>
    <div class="reports-dialog__footer">
      <p-button [label]="'COMMON.CANCEL' | translate" severity="secondary" styleClass="reports-btn reports-btn--ghost notranslate"
        (click)="showCierreDialog = false" />
      <p-button [label]="'REPORTS.BTN_CLOSE_REPORT' | translate" severity="danger" icon="pi pi-lock"
        styleClass="reports-btn reports-btn--danger notranslate" [disabled]="!cuentaOrigenCierre"
        (click)="confirmarCierreConCuenta()" />
    </div>
  </ng-template>
</p-dialog>
